// extracted by mini-css-extract-plugin
export var breadcrumbs = "Breadcrumbs-module--breadcrumbs--276fe";
export var breadcrumbs__back = "Breadcrumbs-module--breadcrumbs__back--c6f88";
export var breadcrumbs__home = "Breadcrumbs-module--breadcrumbs__home--5adaa";
export var breadcrumbs__item = "Breadcrumbs-module--breadcrumbs__item--6b50e";
export var breadcrumbs__seperator = "Breadcrumbs-module--breadcrumbs__seperator--704ba";